<template>
  <div class="home-taiku">
    <!-- Banner轮播 -->
    <el-carousel height="650px" class="tk-banner">
      <el-carousel-item v-for="(img, i) in bannerImgs" :key="i">
        <img :src="img" class="tk-banner-img" loading="eager" />
      </el-carousel-item>
    </el-carousel>

    <!-- 公司简介/优势统计 -->
    <div class="tk-section tk-intro">
      <div class="tk-intro-title">加速您的多肽研究</div>
      <div class="tk-intro-sub">Accelerate your peptide research</div>
      <div class="tk-intro-desc">
        <p>江西辐氨生物技术有限公司，是一家致力于多肽合成研究及多肽定制合成的高新技术企业</p>
        <p>帮助科研单位完成多肽定制生产，帮助新的课题研究提供可行的多肽技术路线</p>
        <p>核心团队具有国内外一流化学行业背景和丰富的研发、管理经验，致力于向国内外相关企业和科研机构提供高品质的多肽产品</p>
      </div>
      <el-row :gutter="20" class="tk-advantage">
        <el-col :span="6">
          <div class="tk-adv-card">
            <img :src="require('@/assets/img/7nian.png')" class="tk-adv-icon" loading="lazy" />
            <div class="tk-adv-num">3<span>年+</span></div>
            <div class="tk-adv-label">多肽合成技术积累</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tk-adv-card">
            <img :src="require('@/assets/img/3000.png')" class="tk-adv-icon" loading="lazy" />
            <div class="tk-adv-num">3000<span>+</span></div>
            <div class="tk-adv-label">常备目录肽现货</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tk-adv-card">
            <img :src="require('@/assets/img/customer.png')" class="tk-adv-icon" loading="lazy" />
            <div class="tk-adv-num">98<span>%</span></div>
            <div class="tk-adv-label">服务客户满意度</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tk-adv-card">
            <img :src="require('@/assets/img/order.png')" class="tk-adv-icon" loading="lazy" />
            <div class="tk-adv-num">80<span>%</span></div>
            <div class="tk-adv-label">业务来源老客户及同行订单</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 主营业务卡片 -->
    <div class="tk-section tk-business">
      <el-row :gutter="20">
        <el-col :span="6" v-for="item in businessList" :key="item.title">
          <div style="height: 100%;">
            <el-card :body-style="{padding:'40px 20px', height: '240px', textAlign: 'center'}">
              <img :src="item.img" class="tk-biz-img" style="width: 120px; height: 80px; object-fit: contain; margin: 0 auto 20px; display: block;" loading="lazy" />
              <div class="tk-biz-title" style="margin-bottom: 10px; font-size: 18px; font-weight: bold;">{{ item.title }}</div>
              <div class="tk-biz-desc" style="color: #666; line-height: 1.5;">{{ item.desc }}</div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 案例展示 -->
    <div class="tk-section tk-case">
      <div class="tk-case-title">案例展示</div>
      <div class="tk-case-title">show case</div>
      <el-row :gutter="20">
        <el-col :span="12" v-for="item in caseList" :key="item.title">
          <el-card :body-style="{padding:'10px'}">
            <img :src="item.img" class="tk-case-img" loading="lazy" />
            <div class="tk-case-label">{{ item.title }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 底部信息 -->
    <div class="tk-footer">
      <div>电话：15002819872&nbsp; 邮箱：15002819872@163.com&nbsp; 地址：江西省赣州市章贡区长征大道12号</div>
      <div>备案号: <a href="https://beian.miit.gov.cn/#/Integrated/index">赣ICP备2026004521号-1</a></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchKey: '',
      bannerImgs: [
        require('@/assets/img/home1.png'),
        require('@/assets/img/home3.png'),
        require('@/assets/img/home4.png'),
        require('@/assets/img/home5.png'),
        require('@/assets/img/home6.png'),
        require('@/assets/img/home7.png')
      ],
      businessList: [
        { img: require('@/assets/img/ca1.png'), title: '现货多肽', desc: '批量生产目录肽及PET探针前体现货，缩短客户研究时间' },
        { img: require('@/assets/img/ca2.png'), title: '定制修饰', desc: '400余种修饰路线，满足研发和生产需求' },
        { img: require('@/assets/img/ca3.png'), title: 'PET探针前体', desc: '可定制生产PET探针前体及中间体' },
        { img: require('@/assets/img/ca4.png'), title: '技术支持', desc: '提供合成路线、结构设计建议' }
      ],
      caseList: [
        { img: require('@/assets/img/case/c1.png'), },
        { img: require('@/assets/img/case/c2.png'), },
        { img: require('@/assets/img/case/c3.png'), },
        { img: require('@/assets/img/case/c4.png'), },
        { img: require('@/assets/img/case/c5.png'), },
        { img: require('@/assets/img/case/c6.png'), },
        { img: require('@/assets/img/case/c7.png'), },
        { img: require('@/assets/img/case/c8.png'), },
        { img: require('@/assets/img/case/c9.png'), },
        { img: require('@/assets/img/case/c10.png'), },
        { img: require('@/assets/img/case/c11.png'), },
        { img: require('@/assets/img/case/c12.png'), },
        { img: require('@/assets/img/case/c13.png'), },
        { img: require('@/assets/img/case/c14.png'), },
        { img: require('@/assets/img/case/c15.png'), },
        { img: require('@/assets/img/case/c16.png'), }


      ],
      paperList: [
        { img: 'https://via.placeholder.com/200x120?text=文献1', title: '功能性多肽的分类及应用', desc: '基于肽作为信号构建块的生物材料设计，提供肽表位库，合成水凝胶分子工具箱。' },
        { img: 'https://via.placeholder.com/200x120?text=文献2', title: '肽大环化的策略', desc: '肽环化的各种构象、结构元素、金属离子促进剂等策略综述。' },
        { img: 'https://via.placeholder.com/200x120?text=文献3', title: '用于癌症治疗的肽基纳米载体', desc: '肽作为纳米载体在癌症治疗中的应用进展综述。' },
        { img: 'https://via.placeholder.com/200x120?text=文献4', title: '基于靶向肽的分子成像与诊断探针', desc: '新型基于肽的分子探针，靶向识别，分子成像。' }
      ]
    }
  },
  methods: {
    handleSearch() {
      this.$message.info('搜索功能待实现: ' + this.searchKey)
    }
  }
}
</script>

<style scoped>
.home-taiku {
  background: #f5f7fa;
  min-height: 100vh;
}
.tk-header {
  background: #fff;
  box-shadow: 0 2px 8px #f0f1f2;
  padding: 0 40px;
  display: flex;
  align-items: center;
  height: 80px;
}
.tk-header-inner {
  display: flex;
  align-items: center;
  width: 100%;
}
.tk-logo {
  height: 60px;
  margin-right: 30px;
}
.tk-nav {
  flex: 1;
}
.tk-search {
  margin-left: 30px;
}
.tk-search-input {
  width: 220px;
}
.tk-banner {
  margin-bottom: 50px;
}
.tk-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #fff;
}
.tk-section {
  max-width: 1200px;
  margin: 30px auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 30px 30px 10px 30px;
}
.tk-intro-title {
  font-size: 28px;
  color: #0e3fa5;
  text-align: center;
  font-weight: bold;
}
.tk-intro-sub {
  font-size: 18px;
  color: #888;
  text-align: center;
  margin-bottom: 10px;
}
.tk-intro-desc {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}
.tk-advantage {
  margin-top: 20px;
  text-align: center;
}
.tk-adv-card {
  padding: 10px 0;
}
.tk-adv-icon {
  height: 70px;
  margin-bottom: 10px;
}
.tk-adv-num {
  font-size: 32px;
  color: #0e3fa5;
  font-weight: bold;
}
.tk-adv-label {
  color: #666;
  font-size: 15px;
  margin-top: 5px;
}
.tk-business {
  margin-top: 50px;
}
.tk-biz-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin: 0 auto 20px;
  display: block;
}
.tk-biz-title {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.tk-biz-desc {
  color: #666;
  line-height: 1.5;
  text-align: center;
}
.tk-case-title {
  font-size: 22px;
  color: #0e3fa5;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}
.tk-case-img {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
.tk-case-label {
  text-align: center;
  color: #666;
  font-size: 15px;
  margin-top: 8px;
}
.tk-paper {
  margin-top: 30px;
}
.tk-paper-title {
  font-size: 22px;
  color: #0e3fa5;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}
.tk-paper-img {
  width: 100%;
  height: 120px;
  object-fit: cover;
}
.tk-paper-title2 {
  font-weight: bold;
  margin: 10px 0 5px 0;
  color: #0e3fa5;
}
.tk-paper-desc {
  color: #666;
  font-size: 14px;
}
.tk-footer {
  background: #2f2f2f;
  color: #fff;
  text-align: center;
  padding: 30px 0 10px 0;
  margin-top: 40px;
}
.tk-footer a {
  color: #fff;
  text-decoration: none;
}

@media (max-width: 768px) {
  .tk-header {
    padding: 0 8px;
    height: 56px;
  }
  .tk-header-inner {
    flex-direction: row;
    padding: 0;
  }
  .tk-logo {
    height: 36px;
    margin-right: 10px;
  }
  .tk-nav {
    font-size: 13px;
  }
  .tk-search {
    margin-left: 8px;
  }
  .tk-search-input {
    width: 120px;
  }
  .tk-banner {
    margin-bottom: 20px;
    height: 140px !important;
    min-height: 100px;
    max-height: 180px;
  }
  .tk-banner-img {
    height: 140px !important;
    min-height: 100px;
    max-height: 180px;
    width: 100vw;
    object-fit: cover;
    display: block;
    background: #fff;
  }
  .tk-section {
    max-width: 100vw;
    margin: 12px 0;
    padding: 12px 4px 4px 4px;
    border-radius: 0;
  }
  .tk-intro-title {
    font-size: 18px;
  }
  .tk-intro-sub {
    font-size: 14px;
  }
  .tk-advantage {
    margin-top: 8px;
  }
  .tk-adv-card {
    padding: 4px 0;
  }
  .tk-adv-icon {
    height: 36px;
  }
  .tk-adv-num {
    font-size: 18px;
  }
  .tk-adv-label {
    font-size: 12px;
  }
  .tk-business {
    margin-top: 20px;
  }
  .tk-biz-img {
    width: 60px;
    height: 60px;
    margin-bottom: 8px;
  }
  .tk-biz-title {
    font-size: 14px;
  }
  .tk-biz-desc {
    font-size: 12px;
  }
  .tk-case-title {
    font-size: 15px;
    margin-bottom: 8px;
  }
  .tk-case-img {
    max-height: 120px;
  }
  .tk-case-label {
    font-size: 12px;
  }
  .tk-paper {
    margin-top: 12px;
  }
  .tk-paper-title {
    font-size: 15px;
    margin-bottom: 8px;
  }
  .tk-paper-img {
    height: 60px;
  }
  .tk-paper-title2 {
    font-size: 13px;
    margin: 6px 0 2px 0;
  }
  .tk-paper-desc {
    font-size: 11px;
  }
  .tk-footer {
    padding: 20px 10px 10px 10px;
    margin-top: 20px;
    font-size: 12px;
    line-height: 1.6;
  }
  .tk-footer div {
    word-break: break-all;
    padding: 0 5px;
  }
  /* 响应式 el-row/el-col 卡片区块 */
  .el-row {
    display: flex;
    flex-wrap: wrap;
  }
  .el-col {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 4px;
  }
  .el-col > div, .el-card {
    width: 100% !important;
    box-sizing: border-box;
  }
  /* 案例展示区域特殊处理，改为单列显示 */
  .tk-case .el-col {
    flex: 1 1 100%;
    max-width: 100%;
  }
  /* 轮播图指示器样式调整，防止换行 */
  .tk-banner >>> .el-carousel__indicators {
    flex-wrap: nowrap !important;
    white-space: nowrap !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    padding: 0 20px !important;
  }
  .tk-banner >>> .el-carousel__indicator {
    flex-shrink: 0 !important;
    padding: 6px 4px !important;
  }
}
</style> 